<template>
<div class="chapter">
<div class="inner_page">
<h1>The Journalist</h1>
<h3 class="sigil_not_in_toc">Dan Newman</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM1_TitlePage.vue?77c52378